import memes from '../memes';

export const getTemperaturePrefix = memes((temperature: number): string => {
	if (Math.round(temperature) > 0) {
		return '+';
	} else if (Math.round(temperature) < 0) {
		return '-';
	}

	return '';
});
